import { render, staticRenderFns } from "./position.vue?vue&type=template&id=499fdcff&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\progect\\guowai\\ex_express_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('499fdcff')) {
      api.createRecord('499fdcff', component.options)
    } else {
      api.reload('499fdcff', component.options)
    }
    module.hot.accept("./position.vue?vue&type=template&id=499fdcff&", function () {
      api.rerender('499fdcff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/index/components/position.vue"
export default component.exports